<template>
    <div class="query-page">
        <el-form v-model="form" :inline="true">
            <el-form-item label="创建时间" prop="datePicker">
                <el-date-picker v-model="datePicker" :editable="false" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            </el-form-item>
            <el-form-item prop="keyWord" label="关键字" class="m-l-50">
                <el-input type="text" class="w-300" v-model="form.keyWord" placeholder="请输入商户名称/商户号/商户登录号"></el-input>
            </el-form-item>
            <el-form-item label="商户账户类型">
                <el-select v-model="form.accountType">
                    <el-option v-for="item in merchTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="search">查询</el-button>
                <el-button @click="addMerchant">新增</el-button>
                <!-- <el-button @click="importMerchant">导入</el-button> -->
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
export default {
  name: 'MQuery',
  data() {
    return {
      datePicker: [],
      form: {
        startTime: '', //开始时间
        endTime: '', //结束时间
        keyWord: '', //关键字
        accountType: '', //商户账户类型
        mainMerchant: '', //分账方商户号
        pageNum: 1,
        pageSize: 10,
      },
      merchTypeList: [
        {
          label: '全部类型',
          value: '',
        },
        {
          label: '商户',
          value: 'merchant',
        },
        {
          label: '个人',
          value: 'userId',
        },
      ],
    };
  },
  methods: {
    search() {
      this.form.startTime = this.datePicker[0];
      this.form.endTime = this.datePicker[1];
      this.form.mainMerchant = JSON.parse(localStorage.getItem('merchantInfo')).hyUid;
      this.$emit('search', this.form);
    },
    addMerchant() {
      this.$emit('addMerchant');
    },
    // importMerchant() {
    //   this.$emit('importMerchant');
    // },
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.query-page {
  margin-top: 10px;
  padding: 15px 20px;
  background-color: #fff;
  border-radius: 5px;
}
.w-300 {
  width: 300px;
}
.m-l-50 {
  margin-left: 50px;
}
</style>
